<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>Reset Password</h3>
    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="save()" color="primary">Update</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <div>
    <div>
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input type="password" formControlName="password" matInput autocomplete="new-password">
      </mat-form-field>
      @if (password.touched && !password.valid) {
        <mat-error>
          Password is required and must be a minimum of 8 characters containing at least one letter and at least one number
        </mat-error>
      }
    </div>
    <div>
      <mat-form-field>
        <mat-label>Confirm Password</mat-label>
        <input type="password" formControlName="confirmPassword" matInput>
      </mat-form-field>
      @if (confirmPassword.touched && confirmPassword.errors?.required) {
        <mat-error>
          Confirm Password is required
        </mat-error>
      }
      @if (confirmPassword.errors?.passwordMismatch) {
        <mat-error>
          Passwords must match
        </mat-error>
      }
    </div>
  </div>
</div>
